import React from 'react';

class Header extends React.Component {
  render() {
    return (
      <div className="header" style={this.props.style}>
        {this.props.children}
      </div>
    );
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js